import { LINKS } from "./links";

export const TEXTS = {
  home: {
    title: "Prossimiti offre Agevolazioni e Servizi per le Imprese",
    subTitle:
      "La nostra realtá supporta la crescita della tua impresa avvalendosi della finanza agevolata",
    help: {
      title:
        "Scrivici per ricevere le agevolazioni su misura per la tua impresa",
      button: {
        title: "CONTATTACI",
        link: LINKS.CONTACTS,
      },
    },
    partners: {
      title: "I nostri partner",
    },
    reports: {
      title: "Certificazione industria 5.0",
      content:
        "Grazie ai nostri ingegneri interni ed alle nostre partnership con EGE ed ESCO possiamo redigere sia perizia asseverate 4.0 che certificazioni 5.0. I nostri consulenti sono a tua disposizione per farti ottenere sempre la massima agevolazione possibile.",
      image: "/images/home/PROSSIMITI-HOMEPAGE-PerizieAsseverate-2.jpg",
      button: {
        title: "SCOPRI DI PIÙ",
        link: LINKS.CERTIFICAZIONE_5,
      },
    },
    pmi: {
      title: "Prossimiti offre agevolazioni e contributi per le PMI",
      content:
        "Siamo una società di consulenza specializzata nel settore della Finanza Agevolata, aiutiamo le imprese nel loro percorso di crescita, tramite l’accesso a contributi ed agevolazioni pubbliche. Qualsiasi sia il tuo progetto, da noi puoi trovare risposta alle tue richieste finanziarie, con agevolazioni adatte alle tue necessità e capaci di dare un nuovo slancio alla tua attività.\n\n​Aiutiamo le imprese nella ricerca ed ottenimento di capitale agevolato per la realizzazione di un progetto.",
      image: "/images/home/prossimiti-home-img3.jpg",
      hyperLinks: [
        {
          title: "Industria 4.0",
          link: LINKS.INDUSTRY_4,
        },
        {
          title: "Industria 5.0",
          link: LINKS.INDUSTRY_5,
        },
        {
          title: "Nuova Sabatini",
          link: LINKS.NUOVA_SABATINI,
        },
        {
          title: "ZES",
          link: LINKS.ZES,
        },
        {
          title: "Finanziamenti Simest",
          link: LINKS.SIMEST,
        },
      ],
      button: {
        title: "CONTATTACI",
        link: LINKS.CONTACTS,
      },
    },
    bannerNewLetter: {
      title:
        "Scrivici per ricevere le agevolazioni su misura per la tua impresa",
      button: {
        title: "CONTATTACI",
        link: LINKS.CONTACTS,
      },
    },
  },
  about: {
    header: {
      header: "Chi siamo",
      title: "Prossimiti: Agevolazioni e Servizi per le Imprese",
    },
    mission: {
      header: "Mission",
      title:
        "Nati dal desiderio di fornire i migliori servizi e la migliore consulenza",
      content:
        "La nostra realtà ti fornisce tutto il supporto per far crescere la tua impresa. Ti offriamo i migliori servizi con la possibilità di agevolarti tutto in un unico pacchetto chiavi in mano.",
      image: "/images/about/prossimiti-about-img1.jpg",
    },
    areas: {
      title: "Le nostre aree di competenza",
      subTitle:
        "Costruiamo soluzioni partendo dalle fondamenta dei problemi, ascoltando le difficoltà delle micro, piccole e medie imprese del territorio.",
    },
    services: {
      title: "Le principali agevolazioni",
      subTitle:
        "Analizzando i bisogni e le esigenze delle imprese, aiutiamo gli imprenditori a trovare le opportunità più convenienti per l’agevolazione dei loro investimenti.",
    },
    contacUs: {
      title: "Hai bisogno di maggiori informazioni?",
      button: {
        title: "CONTATTACI",
        link: LINKS.CONTACTS,
      },
    },
    workflow: {
      header: "Workflow",
      title: "Come lavoriamo",
      content:
        "Un’offerta consulenziale in costante aggiornamento, professionisti qualificati ed una piattaforma smart per la gestione delle tue pratiche.",
      stepOne: {
        index: "/images/about/PROSSIMITI-icon-1.svg",
        title: "Analisi",
        content:
          "Partendo dalle vostre richieste, faremo una analisi della vostra realtà andando ad individuare un ampio numero di soluzioni adatte a voi.",
      },
      stepTwo: {
        index: "/images/about/PROSSIMITI-icon-2.svg",
        title: "Proposta",
        content:
          "I nostri professionisti saranno in grado di selezionare insieme a voi la miglior soluzione sulla base del portafoglio di soluzioni disponibili.",
      },
      stepThree: {
        index: "/images/about/PROSSIMITI-icon-3.svg",
        title: "Implementazione",
        content:
          "Procederemo alla costruzione della soluzione che meglio risponde alle vostre esigenze, stimando tempi di realizzazione, costi e vantaggi.",
      },
      stepFour: {
        index: "/images/about/PROSSIMITI-icon-4.svg",
        title: "Soluzione",
        content:
          "Rispetto delle tempistiche stabilite, qualità dell’offerta proposta, formazione ed accompagnamento verso l’adozione del prodotto scelto, sono i valori a cui diamo più importanza.",
      },
    },
  },
  localAnnouncements: {
    header: {
      header: "Finanza agevolata",
      title: "Bandi sul territorio",
      subTitle: "Agevolazioni per i tuoi progetti",
    },
    europeanFounds: {
      header: "Da dove provengono i fondi?",
      columnOne:
        "Il mondo dei bandi rappresenta la fetta preponderante della Finanza Agevolata. La gestione dei fondi e dei relativi bandi è tutt’altro che semplice e coinvolge un gran numero di istituzioni differenti, articolandosi in una serie di complessi programmi e tipologie di aiuto.\n\nI fondi dalla quale provengono i contributi sono fondi europei, e per tale motivo è l’Unione Europea a dettare gli obiettivi generali che con la Finanza Agevolata si intendono perseguire. Una importante distinzione di tali fondi è quella tra diretti e indiretti.\n\nI fondi europei diretti (noti anche come Programmi Comunitari o Settoriali) sono gestiti dalle Direzioni Generali della Commissione Europea. Vengono resi disponibili alle aziende e agli altri soggetti beneficiari attraverso programmi volti a perseguire gli obiettivi di maggiore rilevanza che l’Europa propone.\n\nI fondi indiretti son invece rappresentati dai fondi strutturali e di investimento europei, i cosiddetti Fondi SIE. Sono strumenti finanziari della politica regionale dell’Unione Europea il cui scopo è quello di ridurre il divario fra le regioni più avanzate e quelle meno sviluppate, rafforzando la coesione economica e sociale. Le risorse messe a disposizione sono gestite mediante Programmi Operativi Nazionali (PON) e Regionali (POR).",
      columnTwo:
        "Oltre a tali fondi, la cui programmazione segue piani settennali, ogni Paese eroga ulteriori risorse tramite la spesa pubblica, incrementando ulteriormente la possibilità per le imprese di rendersi competitive sul mercato.\n\nNegli ultimi anni in Italia ha acquisito sempre maggiore rilevanza il Piano Nazionale Impresa 4.0, un piano strutturale di incentivi a supporto dello sviluppo delle imprese per l’adozione di nuove tecnologie utili alla trasformazione digitale dei processi produttivi. Misure di particolare interesse del piano sono la Nuova Sabatini e il Credito d’imposta beni strumentali 4.0.\n\nIn Prossimiti ci occupiamo di bandi di livello nazionale, regionale, provinciale.",
    },
    discover: {
      title:
        "Scopri quali bandi sono attualmente attivi e crea la soluzione più adatta a te!",
      button: {
        title: "SCOPRI I BANDI",
        link: "/build-your-solution",
      },
    },
    types: {
      header: "Approcci e strategie mirate",
      columnOne:
        "Una buona parte dei bandi che seguiamo sono definiti “a sportello”. Questo tipo di bandi premia la velocità di presentazione della domanda, ammettendo a contributo le aziende non in base alla qualità del progetto (purché sia un progetto ammissibile), quanto piuttosto alla rapidità con cui è inviata la domanda.\n\nDunque, ciò che fa la differenza tra ammissione al contributo o esclusione dallo stesso, è la velocità di reperimento delle informazioni necessarie e la tempestività di invio della domanda. La nostra prerogativa è l’ammissione delle vostre pratiche, per tale motivo ci adoperiamo affinché la vostra domanda venga inviata il giorno stesso di apertura dello sportello.\n\nUn’altra tipologia di bandi è quella “a graduatoria”, in cui le risorse sono erogate ai progetti più meritevoli. La qualità delle iniziative proposte viene valutata sulla base di diversi criteri, premiando quelle che mostrano maggiore coerenza con il bando.",
      columnTwo:
        "In questo tipo di agevolazioni è quindi necessario tralasciare la velocità di presentazione della domanda, focalizzando ogni sforzo sulla bontà del progetto proposto.\n\nLa capacità di formalizzare e presentare iniziative di qualità è il fattore determinante per la vittoria. I nostri professionisti possono aiutarvi a costruire interventi strutturati al fine di farvi ottenere il maggior punteggio possibile.\n\nL’ultima tipologia di bandi è quella automatica, per la quale è presentata domanda secondo le disposizioni di legge. Tali fondi automatici sono erogati direttamente dallo stato, senza l’ausilio di intermediari, esclusivamente se il ricevente rispetta i parametri richiesti dall’agevolazione.",
    },
    support: {
      title: "Come ti Supportiamo",
      steps: [
        {
          title: "Ascolto",
          content:
            "Ascoltiamo le tue esigenze ed eseguiamo un’analisi preliminare delle caratteristiche della tua azienda e del tuo progetto.",
          icon: "/images/local/PROSSIMITI-icon-Ascolto2.svg",
        },
        {
          title: "Focus",
          content:
            "Individuiamo le migliori opportunità agevolative, quelle che meglio si adattano allo sviluppo strategico della tua attività.",
          icon: "/images/local/PROSSIMITI-icon-Focus.svg",
        },
        {
          title: "Know How Operativo",
          content:
            "Forniamo un supporto operativo e strategico. Operativo per presentare la domanda in maniera corretta, strategico per scrivere progetti vincenti.",
          icon: "/images/local/PROSSIMITI-icon-KnowHowOperativo.svg",
        },
        {
          title: "Supporto",
          content:
            "Accompagniamo ogni tuo passo durante tutte le fasi di sviluppo del bando, fino all’erogazione del contributo.",
          icon: "/images/local/PROSSIMITI-icon-Supporto.svg",
        },
      ],
    },
    services: {
      title: "Le principali agevolazioni",
      subTitle:
        "Analizzando i bisogni e le esigenze delle imprese, aiutiamo gli imprenditori a trovare le opportunità più convenienti per l’agevolazione dei loro investimenti.",
      services: [
        {
          title: "Consulenza 4.0",
          content:
            "Perizie asseverate sui tuoi nuovi beni 4.0 materiali ed immateriali",
          image:
            "/images/finance/PROSSIMITI-FINANZAAGEVOLATA-Servizio-Consulenza40-thumb.jpg",
          button: {
            title: "LE NOSTRE SOLUZIONI",
            link: "/credit",
          },
        },
        {
          title: "Nuova Sabatini",
          content:
            "Finanziamenti agevolati per rinnovare macchinari e attrezzature",
          image:
            "/images/finance/PROSSIMITI-FINANZAAGEVOLATA-Servizio-NuovaSabatini-thumb.jpg",
          button: {
            title: "LE NOSTRE SOLUZIONI",
            link: "/nuova-sabatini",
          },
        },
        {
          title: "Espansione internazionale",
          content:
            "Fondi di Sace Simest per espanderti verso i mercati esteri (fiere e e-commerce)",
          image:
            "/images/finance/PROSSIMITI-FINANZAAGEVOLATA-Servizio-Internazionalizzazione-thumb.jpg",
          button: {
            title: "LE NOSTRE SOLUZIONI",
            link: "/international",
          },
        },
      ],
    },
  },
  finance: {
    header: {
      title: "Finanza Agevolata",
      subTitle: "Un’opportunità unica per te",
    },
    whatsIs: {
      header: "Una via alternativa al prestito bancario",
      title: "Cos’è la Finanza Agevolata, e perché non puoi farne a meno",
      content:
        "La Finanza Agevolata racchiude gli strumenti utilizzati dal legislatore a livello comunitario per aiutare le imprese a realizzare i loro progetti di sviluppo ed investimento innovativi.\n\nI mezzi adoperati sono di carattere finanziario e fiscale.\n\nGli incentivi concessi supportano le spese sostenute in aree che rappresentano per le imprese opportunità di crescita, quali attività di ricerca e sviluppo, digitalizzazione, investimenti in capitale e competenze, risorse umane, risparmio energetico, innovazione.\n\nInoltre, sono presenti strumenti che favoriscono l’internazionalizzazione e la competitività delle imprese che cercano di espandersi oltre-confine.",
      image: "/images/finance/PROSSIMITI-FINANZAAGEVOLATA-img1.jpg",
      button: {
        title: "LE NOSTRE SOLUZIONI",
        link: "/build-your-solution",
      },
    },
    concessions: {
      title: "Le Agevolazioni",
      content:
        "Nonostante la grande varietà di agevolazioni messe a disposizione dalla Finanza Agevolata,\npossiamo individuare quattro macro categorie di aiuti:",
      steps: [
        {
          title: "Contributi a fondo perduto",
          content:
            "Calcolato in percentuale sulle spese ammissibili,non prevede restituzione di capitale o pagamento di interessi.",
          icon: "/images/finance/PROSSIMITI-icon-ContributiAFondoPerduto.svg",
        },
        {
          title: "Finanziamenti agevolati",
          content:
            "Riduzione dell’interesse sul prestito o concessione di finanziamenti a condizione favorevoli.",
          icon: "/images/finance/PROSSIMITI-icon-FinanziamentiAgevolati.svg",
        },
        {
          title: "Interventi in conto garanzia",
          content: "Concessione di garanzie a valere sui fondi pubblici.",
          icon: "/images/finance/PROSSIMITI-icon-InterventiInContoGaranzia.svg",
        },
        {
          title: "Crediti d’imposta e Incentivi fiscali",
          content:
            "Agevolazioni fiscali che permettono di compensare debiti fiscali, diminuendo le imposte dovute.",
          icon: "/images/finance/PROSSIMITI-icon-CreditiDImpostaEIncentiviFiscali.svg",
        },
      ],
    },
    services: {
      title: "I nostri Servizi",
      subTitle:
        "Analizzando i bisogni e le esigenze delle imprese, aiutiamo gli imprenditori a trovare le opportunità più convenienti per l’agevolazione dei loro investimenti.",
      services: [
        {
          title: "Bandi nazionali, regionali e provinciali",
          content:
            "Agevolazioni e contributi a fondo perduto su qualsiasi tipologia di investimento.",
          image:
            "/images/finance/PROSSIMITI-FINANZAAGEVOLATA-Servizio-BandiNazionaliRegionaliProvinciali-thumb.jpg",
          button: {
            title: "LE NOSTRE SOLUZIONI",
            link: "/build-your-solution",
          },
        },
        {
          title: "Consulenza 4.0",
          content:
            "Perizie asseverate sui tuoi nuovi beni 4.0 materiali ed immateriali",
          image:
            "/images/finance/PROSSIMITI-FINANZAAGEVOLATA-Servizio-Consulenza40-thumb.jpg",
          button: {
            title: "LE NOSTRE SOLUZIONI",
            link: "/credit",
          },
        },
        {
          title: "Nuova Sabatini",
          content:
            "Finanziamenti agevolati per rinnovare macchinari e attrezzature",
          image:
            "/images/finance/PROSSIMITI-FINANZAAGEVOLATA-Servizio-NuovaSabatini-thumb.jpg",
          button: {
            title: "LE NOSTRE SOLUZIONI",
            link: "/nuova-sabatini",
          },
        },
        {
          title: "Espansione Internazionale",
          content:
            "Fondi di Sace Simest per espanderti verso i mercati esteri (fiere e e-commerce)",
          image:
            "/images/finance/PROSSIMITI-FINANZAAGEVOLATA-Servizio-Internazionalizzazione-thumb.jpg",
          button: {
            title: "LE NOSTRE SOLUZIONI",
            link: "/international",
          },
        },
      ],
    },
    help: {
      title: "Come possiamo Aiutarti",
      content:
        "Seguendo un processo ordinato e lineare siamo in grado di offrirti la migliore soluzione possibile, permettendoti di agevolare al meglio i tuoi progetti.",
      button: {
        title: "CONTATTACI",
        link: LINKS.CONTACTS,
      },
    },
    steps: [
      {
        title: "Raccolta",
        content:
          "Aggiorniamo costantemente la nostra banca dati delle agevolazioni, studiando per ognuna di esse ogni singolo aspetto normativo e procedurale.",
        icon: "/images/finance/PROSSIMITI-icon-Raccolta.svg",
      },
      {
        title: "Divulgazione",
        content:
          "Promuoviamo attraverso tutti nostri canali le nuove opportunità di agevolazione, informando il nostro pubblico in maniera tempestiva.",
        icon: "/images/finance/PROSSIMITI-icon-Divulgazione.svg",
      },
      {
        title: "Ascolto",
        content:
          "Ascoltiamo le esigenze dei nostri clienti, attuali e potenziali, eseguendo un’ analisi preliminare gratuita delle caratteristiche dell’azienda.",
        icon: "/images/finance/PROSSIMITI-icon-Ascolto.svg",
      },
      {
        title: "Verifica",
        content:
          "Verifichiamo il possesso da parte dell’azienda dei requisiti previsti dalle singole agevolazioni e la possibilità di cumulare più strumenti.",
        icon: "/images/finance/PROSSIMITI-icon-Verifica.svg",
      },
      {
        title: "Proposta",
        content:
          "Presentiamo all’azienda le soluzioni che meglio rispondono alle sue necessità, decidendo insieme la soluzione finale.",
        icon: "/images/finance/PROSSIMITI-icon-Proposta.svg",
      },
      {
        title: "Esecuzione",
        content:
          "Prepariamo la modulistica prevista, supportiamo la scrittura del progetto e assistiamo il cliente da vicino in tutti i passaggi burocratici.",
        icon: "/images/finance/PROSSIMITI-icon-Esecuzione.svg",
      },
    ],
  },
  softwareMES: {
    header: {
      header: "Servizi",
      title: "SOFTWARE MES 4.0",
      subTitle: "Cogli le opportunità della quarta rivoluzione industriale",
    },
    manufacturing: {
      header: "Il tuo reparto produttivo sotto controllo",
      title: "Manufacturing Execution System",
      subTitle: "OTTIMIZZA LA TUA GESTIONE AZIENDALE",
      content:
        "Il software MES (Manufacturing Execution System) è uno strumento fondamentale nel paradigma “Industria 4.0” in quanto permette di implementare le funzionalità necessarie a gestire, ottimizzare e controllare in tempo reale i processi produttivi dell’azienda, interfacciando sistemi gestionali e linee di produzione in conformità ai requisiti Industria 4.0.\n\nIl sistema che proponiamo, semplice e intuitivo, risponde a tutte le necessità delle aziende che vogliono usufruire degli incentivi di Industria 4.0 (Credito d’Imposta 4.0), ottimizzando tempi e risorse.\n\nIl MES permette di eseguire e governare tutte le funzioni produttive, dal rilascio dell’ordine al prodotto finito: è considerato l’anello di congiunzione tra il livello decisionale e il livello produttivo dell’azienda.",
      image: "/images/software/PROSSIMITI-SoftwareMES-img1.png",
      button: {
        title: "CONTATTACI",
        link: LINKS.CONTACTS,
      },
    },
    informations: {
      header: "Dati aggiornati in tempo reale",
      title: "Informazioni precise e aggiornate, tutte in un unica Dashboard",
      content:
        "Il MES è in grado di acquisire dati in real time, garantendo l’ottenimento di informazioni precise e costantemente aggiornate. Tali informazioni sono visualizzate mediante dashboard semplici e chiare, le quali consentono di individuare in tempo reale scostamenti e criticità, con la possibilità di reagire in maniera tempestiva tramite azioni correttive\n\n​Il sistema MES, risulta dunque un efficace strumento per monitorare, gestire e migliorare l’impianto produttivo, permettendo di eliminare le attività a non valore aggiunto e di incrementare l’efficienza produttiva dello stabilimento.\n\nL’introduzione di un sistema MES può diventare l’occasione per ristrutturare l’intera organizzazione aziendale, stabilendo obiettivi di miglioramento misurabili già nel breve periodo.",
      image: "/images/software/PROSSIMITI-SoftwareMES-img2.png",
    },
    contactUs: {
      title: "Hai bisogno di ulteriori informazioni riguardo al Software?",
      button: {
        title: "CONTATTACI",
        link: LINKS.CONTACTS,
      },
    },
    fdc: {
      header: "Integrazione e interconnessione",
      title: "Tecnologia FDC 4.0",
      content:
        "La tecnologia innovativa FDC 4.0 (Field Data Collector 4.0), applicando tecnologie parametriche e programmazione Event Driven, permette l’integrazione con gli impianti produttivi e l’acquisizione dei dati direttamente dalle macchine.\n\nL’FDC è un collettore di dati provenienti dal campo che crea una “base di dati” permettendo così lo scambio dati con il software MES 4.0. L’integrazione della tecnologia FDC con il sistema informativo di fabbrica risolve quindi i requisiti di Industria 4.0 (Transizione 4.0).\n\nLa tecnologia FDC permette di interconnettere una nuova macchina/ impianto grazie allo sviluppo del modulo che implementa il protocollo di comunicazione specifico.\n\nNel caso in cui le macchine non siano dotate di dispositivi di controllo siamo in grado di fornire la consulenza per l’installazione di sensori sui dispositivi di produzione.",
      image: "/images/software/PROSSIMITI-SoftwareMES-img3.jpg",
    },
    steps: {
      title: "Funzionalità del MES",
      content:
        "Il sistema che proponiamo è dotato un gran numero di funzionalità in grado di soddisfare tutte le esigenze del tuo reparto produttivo",
      stepOne: {
        title: "Integrazione e interconnessione",
        content:
          "Integrazione con sistemi informativi aziendali (gestionali, ERP,…) con tecnologie Rest, Soap, Odbc e soluzioni custom. Interconnessione impianti produttivi e macchine tra cui FANUC, DMG MORI, CITIZEN, SIEMENS, HEIDENHAIN, MAZAK, OKUMA, FAGOR, PADE, BACCI, CMS, BALESTRINI.",
        icon: "/images/software/PROSSIMITI-icon-IntegrazioneEInterconnessione.svg",
      },
      stepTwo: {
        title: "Automazione produzione",
        content:
          "Invio dati di produzione e ordini di lavorazione agli operatori a bordo macchina in formato digitale. Presa in carico degli ordini direttamente a bordo macchina da parte degli operatori.",
        icon: "/images/software/PROSSIMITI-icon-AutomazioneProduzione.svg",
      },
      stepThree: {
        title: "Analisi in tempo reale",
        content:
          "Dashboard visuale per l’analisi in tempo reale della produzione (quantità prodotta, scarti, tempi, …) e del calcolo degli indicatori OEE. Rappresentazione in forma schematica e sintetica della situazione in tempo reale di tutto il reparto produttivo su un sinottico.",
        icon: "/images/software/PROSSIMITI-icon-AnalisiInTempoReale.svg",
      },
      stepFour: {
        title: "Tracciabilità e controllo qualità",
        content:
          "Tracciabilità completa dei lotti in relazione agli ordini di lavoro, dei consumi dei materiali e dei livelli di inventario. Rilevazione della qualità direttamente dagli operatori a bordo macchina che permette di reagire tempestivamente ed evitare produzione di sprechi.",
        icon: "/images/software/PROSSIMITI-icon-TracciabilitaEControlloQualita.svg",
      },
      stepFive: {
        title: "Archiviazione dati e statistiche",
        content:
          "Raccolta dati automatica ed esaustiva dai macchinari e dall’operatore a bordo macchina. Archiviazione dati raccolti per una successiva analisi delle performance con tecnologie di Business Intelligence (BI).",
        icon: "/images/software/PROSSIMITI-icon-ArchiviazioneDatiEStatistiche.svg",
      },
      stepSix: {
        title: "Usabilità",
        content:
          "Software semplice da utilizzare, grafica intuitiva e personalizzabile sia nell’interfaccia che nelle funzionalità. Interfaccia responsive e touch-screen per essere utilizzato su tablet, smartphone, palmari e pc a bordo macchina, anche con dispositivi di protezione personale indossati.",
        icon: "/images/software/PROSSIMITI-icon-Digitalizzazione.svg",
      },
      stepSeven: {
        title: "Digitalizzazione",
        content:
          "Presenza di tablet a bordo macchina per gestire gli avanzamenti di produzione direttamente dai reparti produttivi. Presenza di dashboard di statistiche e sinottico per il controllo in tempo reale del reparto produttivo.",
        icon: "/images/software/PROSSIMITI-icon-IntegrazioneEInterconnessione.svg",
      },
    },
    benefits: {
      title: "Benefici del MES",
      steps: [
        {
          content:
            "Soddisfacimento dei requisiti di integrazione e interconnessione, necessari per accedere al credito d’Imposta 4.0",
        },
        {
          content:
            "Completa visibilità e controllo in tempo reale di tutte le attività produttive",
        },
        {
          content:
            "Gestione avanzamenti di produzione direttamente dai reparti produttivi mediante tablet a bordo macchina",
        },
        {
          content:
            "Digitalizzazione ordini di produzione e schede di lavorazione",
        },
        {
          content:
            "Diminuzione sprechi (scarti, tempi morti, movimentazioni inutili, errori dovuti ad informazioni incomplete)",
        },
        {
          content:
            "Sfruttamento ottimale delle risorse produttive (macchine, dipendenti, magazzino)",
        },
        {
          content:
            "Acquisizione dati in automatico da macchine e operatori e creazione di statistiche di produzione puntuali visualizzate su dashboard",
        },
        {
          content:
            "Miglioramento servizio clienti in termini di velocità, qualità, puntualità",
        },
      ],
    },
    concess: {
      title: "Agevola i tuoi beni con il Credito d’Imposta",
      columnOne:
        "Il Piano Nazionale Industria 4.0 mette a disposizione importanti agevolazioni fiscali, sotto forma di Credito d’Imposta, sull’acquisto di nuovi macchinari 4.0. Per accedere a tali incentivi, i beni devono rispettare una serie di requisiti normativi: grazie alla nostra soluzione è possibile soddisfare perfettamente tutti i requisiti, inclusi i due più complessi, ovvero interconnessione e integrazione.\n\nL’inserimento di un software MES ti permette quindi non solo di migliorare l’efficienza della produzione, ma anche di ottenere consistenti incentivi fiscali sui tuoi nuovi beni 4.0.",
      columnTwo:
        "In Prossimiti siamo in grado di fornirti una soluzione completa compresa di:\n\nAnalisi del tuo sistema produttivo e installazione del software MES\n\nPerizia tecnica asseverata sul macchinario 4.0 (al fine di ottenere il credito d’imposta 4.0 sui beni materiali\n\nPerizia tecnica asseverata sul software MES installato al fine di ottenere il credito d’imposta 4.0 sui beni immateriali",
    },
    modules: {
      title: "Un sistema Modulare",
      content:
        "Il MES è composto da una serie di moduli perfettamente integrati e complementari tra loro, in grado di soddisfare tutte le esigenze di un sistema produttivo.",
      list: [
        {
          title: "Modulo Produzione",
          content:
            "Ordini di Produzione. Permette di effettuare una gestione totale della produzione. Le principali funzioni del modulo sono: gestione completa di un ordine di produzione, gestione degli articoli con distinta base.",
          image:
            "/images/software/PROSSIMITI-SoftwareMES-ModuloProduzione-1.jpg",
        },
        {
          title: "Modulo Produzione",
          content:
            "Dashboard con i dati della produzione ed indice OEE. Permette di effettuare una gestione totale della produzione. Le principali funzioni del modulo sono: gestione completa di un ordine di produzione, gestione degli articoli con distinta base.",
          image:
            "/images/software/PROSSIMITI-SoftwareMES-ModuloProduzione-2.jpg",
        },
        {
          title: "Modulo Controllo Macchina",
          content:
            "Gestione centro di lavoro. Permette il monitoraggio e il controllo di più macchinari contemporaneamente, grazie ad un’interfaccia estremamente intuitiva. Utilizzabile anche in ambienti difficili o da operatori che indossano DPI.",
          image:
            "/images/software/PROSSIMITI-SoftwareMES-ModuloControlloMacchina.jpg",
        },
        {
          title: "Modulo Gestione Qualità",
          content:
            "Controllo qualità. Permette di gestire il controllo di qualità durante il processo produttivo, al fine di migliorare la qualità della produzione ed ottenere la certificazione del prodotto.",
          image:
            "/images/software/PROSSIMITI-SoftwareMES-ModuloGestioneQualità.jpg",
        },
        {
          title: "Modulo “Sinottico”",
          content:
            "Permette di visualizzare un monitor nel quale sono contenuti i dati in tempo reale di tutte le macchine collegate al MES. Per ogni macchinario è possibile visualizzare dati quali lo stato di funzionamento, i dati della commessa in lavorazione, il numero di pezzi prodotti e di scarti.",
          image: "/images/software/PROSSIMITI-SoftwareMES-ModuloSinottico.jpg",
        },
        {
          title: "Modulo Gestione Magazzino",
          content:
            "Gestione magazzino. Permette la gestione di commesse, articoli e magazzini, con la possibilità di essere completamente integrato con il sistema ERP aziendale. Garantisce una gestione manuale e automatica dei magazzini prodotti grezzi, finiti e scarti.",
          image:
            "/images/software/PROSSIMITI-SoftwareMES-ModuloGestioneMagazzino.jpg",
        },
      ],
    },
    services: {
      title: "Scopri gli altri servizi",
      subTitle:
        "Analizzando i bisogni e le esigenze delle imprese, aiutiamo gli imprenditori a trovare le opportunità più convenienti per l’agevolazione dei loro investimenti.",
      services: [
        {
          title: "Gestione contributi",
          content: "Gestione in toto dei contributi italiani ed europei",
          image:
            "/images/finance/PROSSIMITI-FINANZAAGEVOLATA-Servizio-Consulenza40-thumb.jpg",
          button: {
            title: "LE NOSTRE SOLUZIONI",
            link: "/gestione-contributi",
          },
        },
        {
          title: "Certificazione industria 5.0",
          content:
            "Certificazione ex ante, ex post e comunicazioni al Gse per Industria 5.0",
          image:
            "/images/finance/PROSSIMITI-FINANZAAGEVOLATA-Servizio-NuovaSabatini-thumb.jpg",
          button: {
            title: "LE NOSTRE SOLUZIONI",
            link: "/certificazione-industra-5-0",
          },
        },
        {
          title: "Perizie Bando Isi Inail",
          content: "Perizie per presentare domanda al bando Isi Inail",
          image:
            "/images/finance/PROSSIMITI-FINANZAAGEVOLATA-Servizio-Internazionalizzazione-thumb.jpg",
          button: {
            title: "LE NOSTRE SOLUZIONI",
            link: "/perizie-bando-isi-inail",
          },
        },
        {
          title: "Perizie Bando Isi Inail",
          content: "Perizie per presentare domanda al bando Isi Inail",
          image:
            "/images/finance/PROSSIMITI-FINANZAAGEVOLATA-Servizio-Internazionalizzazione-thumb.jpg",
          button: {
            title: "LE NOSTRE SOLUZIONI",
            link: "/perizie-bando-isi-inail",
          },
        },
      ],
    },
  },
  contacts: {
    header: {
      title: "Contattaci",
      subTitle: "Ti risponderemo al più presto!",
    },
  },
  partners: {
    header: {
      title: "I partners di Prossimiti",
    },
  },
  industryFour: {
    header: {
      header: "Agevolazioni in evidenza",
      title: "INDUSTRIA 4.0",
      subTitle: "Innovazione tecnologica e digitale nei processi industriali",
    },
    capitalGoods: {
      header: "Come  funziona?",
      columnOneTitle: "L’incentivo",
      columnOne:
        "Il Piano Transizione 4.0, precedentemente noto come Industria 4.0, è un programma governativo che offre incentivi fiscali per digitalizzare le imprese italiane destinato alle imprese con strutture produttive ubicate in Italia. Grazie all’agevolazione è possibile ottenere un credito di imposta a seguito dell’acquisto di beni strumentali materiali (macchinari, macchine mobili, sistemi di controllo della qualità ecc.). A seguito dell’approvazione della legge di bilancio 2025 i beni immateriali, ovvero i software non saranno più agevolati.",
      columnTwoTitle: "Obiettivi",
      columnTwo:
        "L’obiettivo del piano è migliorare la digitalizzazione della propria impresa, favorendo lo scambio di dati nei processi aziendali. L’investimento agevola quindi investimenti in beni strumentali nuovi e tecnologicamente avanzati. Include macchinari e attrezzature interconnessi ai sistemi informatici, robotica avanzata, dispositivi IoT, sistemi di automazione, software per gestione e analisi dati, realtà aumentata e virtuale, soluzioni di cybersecurity, stampanti 3D e tecnologie per la manifattura additiva.",
    },
    table: {
      title: "Agevolazione prevista",
      content:
        "Il Credito d’Imposta, utilizzabile esclusivamente in compensazione in tre quote annuali di pari importo, è applicabile ai beni 4.0 che rispettano le 5 + 2 caratteristiche. Di seguito le percentuali dell’agevolazione:",
      subContent:
        "*Nella legge di Bilancio 2025 sono stati stanziati 2,2 miliardi di fondi per l’annualità 2025. Al termine della dotazione non sarà più possibile accedere al credito anche se l’anno 2025 non è ancora terminato.",
    },
    services: {
      title: "Le principali agevolazioni",
      subTitle:
        "Analizzando i bisogni e le esigenze delle imprese, aiutiamo gli imprenditori a trovare le opportunità più convenienti per l’agevolazione dei loro investimenti.",
    },
  },
  nuovaSabatini: {
    header: {
      header: "Agevolazioni in evidenza",
      title: "NUOVA SABATINI",
      subTitle: "Contributo in conto impianti su finanziamenti o leasing",
    },
    capitalGoods: {
      header: "Come  funziona?",
      columnOneTitle: "L’incentivo",
      columnOne:
        "La Nuova Sabatini è un'agevolazione per le piccole e medie imprese (PMI) italiane che facilita l'accesso al credito per l'acquisto o il leasing di beni strumentali nuovi, come macchinari, impianti, attrezzature, hardware e software. Prevede un finanziamento agevolato tramite banche convenzionate e un contributo in conto interessi erogato dal Ministero dello Sviluppo Economico, riducendo il costo dell'investimento",
      columnTwoTitle: "Obiettivi",
      columnTwo:
        "La Nuova Sabatini mira a facilitare l'accesso al credito per le piccole e medie imprese (PMI) italiane, incentivando gli investimenti in beni strumentali nuovi a uso produttivo. Con l’obiettivo di sostenere la competitività e l'innovazione delle PMI, favorire l'ammodernamento di macchinari, impianti e attrezzature, promuovere l'adozione di tecnologie digitali, hardware e software e stimolare la crescita economica e l'occupazione attraverso investimenti produttivi.",
    },
    table: {
      title: "Agevolazione prevista",
      content:
        "La nuova sabatini, utilizzabile solo tramite finanziamento bancario o leasing, è un contributo in conto impianti il cui ammontare è determinato in misura pari al valore degli interessi calcolati, in via convenzionale, su un finanziamento della durata di cinque anni e di importo uguale all’investimento. Di seguito le aliquote:",
      subContent:
        " Il finanziamento, che può essere assistito dalla garanzia del “Fondo di garanzia per le piccole e medie imprese”, deve essere di durata non superiore a 5 anni, di importo compreso tra 20.000 euro e 4 milioni di euro, interamente utilizzato per coprire gli investimenti ammissibili",
    },
    services: {
      title: "Le principali agevolazioni",
      subTitle:
        "Analizzando i bisogni e le esigenze delle imprese, aiutiamo gli imprenditori a trovare le opportunità più convenienti per l’agevolazione dei loro investimenti.",
    },
  },
  industryFive: {
    header: {
      header: "Agevolazioni in evidenza",
      title: "INDUSTRIA 5.0",
      subTitle: "Agevolazioni per beni strumentali in ottica sostenibile",
    },
    capitalGoods: {
      header: "Come  funziona?",
      columnOneTitle: "L’incentivo",
      columnOne:
        "Agevolazione con un ammontare di risorse pari a 6,3 miliardi di euro per il biennio 2024-2025, incentiva, con un credito di imposta, beni strumentali materiali ed immateriali che comportano una riduzione dei consumi di almeno il 3% dell'unità produttiva o 5% se calcolata sul processo interessato dall'investimento. L’incentivo agevola anche gli investimenti in impianti per l’autoproduzione di energia e la formazione.\n\nNOVITA’\nUna Faq, inserita nell’agevolazione il 2 Novembre 2024, ammette automaticamente la sostituzione di un bene completamente ammortizzato civilmente da almeno 24 mesi con uno nuovo almeno all’aliquota minima, pari al 35% di credito di imposta (senza necessità della riduzione dei consumi).",
      columnTwoTitle: "Obiettivi",
      columnTwo:
        "L’obiettivo finale dell’Industria 5.0 è creare un ambiente di lavoro che promuova l’innovazione, l’efficienza e la sostenibilità. Ciò comporta una riorganizzazione dei processi produttivi, la formazione delle risorse umane per acquisire competenze digitali e la creazione di un ambiente collaborativo in cui le persone e le macchine possano lavorare insieme in modo sinergico. Non secondario il fine di incentivare l’acquisto di pannelli fotovoltaici prodotti in Europa.",
    },
    table: {
      title: "Agevolazione prevista",
      content:
        "Il Credito d’Imposta, utilizzabile esclusivamente in compensazione nel'anno della chiusura dell'investimento e, la parte rimanente, in cinque quote annuali di pari importo. Di seguito le percentuali dell'agevolazione",
      subContentTitle: "FOTOVOLTAICO",
      subContent:
        "Il fotovoltaico (solo per autoconsumo) può essere un elemento trainato. A seguito dell’approvazione della legge di bilancio 2025 è possibile ricevere un credito di imposta che varia in base alla tipologia di pannelli:\nTipologia a: moduli fotovoltaici prodotti negli Stati membri dell’Unione Europea con un’efficienza a livello di modulo almeno pari a 21,5%\nTipologia b: moduli fotovoltaici con celle, prodotti negli Stati membri dell’Unione Europea con un’efficienza a livello di modulo almeno pari al 23,5%\nTipologia c: moduli prodotti negli Stati UE composti da celle bifacciali ad etero-giunzione di silicio o tandem prodotte UE con un’efficienza di cella almeno pari al 24%.\nIl credito di imposta è pari al 130% per la tipologia a, 140% della tipologia b, 150% per la tipologia c rispetto al credito ottenuto grazie alla riduzione dei consumi.",
      subContent2Title: "ESEMPIO NUMERICO:",
      subContent2:
        "Costo imponibile macchinario Allegato A pari a 100.000 €, costo imponibile del fotovoltaico pari a 100.000 €. Riduzione dei consumi grazie alla sostituzione di un macchinario pari al 7% del processo interessato. Impianto fotovoltaico costruito con pannelli tipologia a.\nL’aliquota del macchinario è pari al 35%, sul macchinario si avrà un credito di imposta pari a (100.000 € *0,35) = 35.000 €.\nL’aliquota per il fotovoltaico è pari a (35*0,3)+35 = 45,50%. Sul fotovoltaico si avrà un credito pari a (100.000 € *0,4550) = 45.500 €.\nTotale credito di imposta a fronte di un investimento pari a 200.000 €  -->  80.500 €\nL’azienda riesce a scontare nel corso del 2025 solo un credito di imposta pari a 50.500 €.\nIl restante credito andrà suddiviso nelle successive 5 annualità in parti uguali, quindi si avrà:\n2026: 30.000/5 --> 6000 €\n2027: 30.000/5 --> 6000 €\n2028: 30.000/5 --> 6000 €\n2029: 30.000/5 --> 6000 €\n2030: 30.000/5 --> 6000 €",
    },
    pdf: {
      title: "SCARICA LA NOSTRA BROCHURE",
      link: "https://prossimiti-bucket-public.s3.eu-south-1.amazonaws.com/brochure_Industria_5_0.pdf",
    },
    services: {
      title: "Le principali agevolazioni",
      subTitle:
        "Analizzando i bisogni e le esigenze delle imprese, aiutiamo gli imprenditori a trovare le opportunità più convenienti per l’agevolazione dei loro investimenti.",
    },
  },
  zes: {
    header: {
      header: "Agevolazioni in evidenza",
      title: "ZES",
      subTitle:
        "Agevolazioni per imprese del Sud e delle zone economiche speciali",
    },
    capitalGoods: {
      header: "Come  funziona?",
      columnOneTitle: "L’incentivo",
      columnOne:
        "Agevolazione dedicata a piccole, Medie e Grandi Imprese localizzate nelle regioni Campania, Puglia, Calabria, Sicilia, Basilicata, Molise, Sardegna e Abruzzo. Per localizzazione si intende la presenza o la futura apertura di una sede operativa all’interno dell’area geografica oggetto dell’incentivo. L’incentivo rinnovato nel 2025 con uno stanziamento pari a 2,2 miliardi di € agevola spese per Macchinari, Impianti, attrezzature, terreni o acquisizione, realizzazione o ampliamento di immobili strumentali agli investimenti.",
      columnTwoTitle: "Obiettivi",
      columnTwo:
        "Obiettivo dell’agevolazione è il rilancio del Mezzogiorno grazie a nuovi investimenti di imprese del Sud o nuove aperture nei territori del Sud da parte di imprese del Nord e Centro Italia. Mira a finanziare progetti con importi elevati con un investimento da minimo 200.000 euro fino a massimo 100 milioni di euro. Le aliquote sono diverse in base alle regioni nella quale si svolge l’investimento e differiscono anche rispetto la dimensione di impresa che presenta domanda.",
    },
    table: {
      title: "Agevolazione prevista",
      content:
        "Finanziabili la creazione di un nuovo stabilimento; l’ampliamento della capacità di uno stabilimento esistente; la diversificazione della produzione di uno stabilimento per ottenere prodotti mai fabbricati precedentemente; un cambiamento fondamentale del processo produttivo complessivo di uno stabilimento esistente, a condizione che l’attività d’impresa rimanesse in area Zes per almeno sette anni dal completamento dell’investimento.",
      subContent:
        "*Questo Credito è compatibile e quindi cumulabile con altri aiuti previsti per la Transizione 4.0\n*Questo credito è cumulabile con Industria 5.0\n*La finestra di tempo entro cui devono presentare tale domanda sarà dal 14 Aprile al 30 Maggio 2025.",
    },
    pdf: {
      title: "SCARICA LA NOSTRA BROCHURE",
      link: "https://prossimiti-bucket-public.s3.eu-south-1.amazonaws.com/brocure_ZES.pdf",
    },
    services: {
      title: "Le principali agevolazioni",
      subTitle:
        "Analizzando i bisogni e le esigenze delle imprese, aiutiamo gli imprenditori a trovare le opportunità più convenienti per l’agevolazione dei loro investimenti.",
    },
  },
  simest: {
    header: {
      header: "Agevolazioni in evidenza",
      title: "FINANZIAMENTI SIMEST",
      subTitle: "Agevolazioni legate all’internazionalizzazione delle PMI",
    },
    capitalGoods: {
      header: "Come  funziona?",
      columnOneTitle: "L’incentivo",
      columnOne:
        "Simest offre agevolazioni finanziarie per supportare le imprese italiane nell'internazionalizzazione e nell'espansione sui mercati esteri. Le misure includono finanziamenti agevolati e contributi a fondo perduto per l’apertura di sedi o uffici commerciali all'estero, la partecipazione a fiere internazionali, studi di fattibilità e programmi di assistenza tecnica, sviluppo di piattaforme e-commerce internazionali, Temporary manager, transizione digitale o ecologica",
      columnTwoTitle: "Obiettivi",
      columnTwo:
        "L’obiettivo dei finanziamenti Simest è fornire supporto per consentire la partecipazione a fiere e mostre internazionali (anche in Italia) o agevolare l’inserimento commerciale in nuovi mercati. Ma anche per favorire lo sviluppo dell’e-commerce o integrare figure professionali dedicate all’internazionalizzazione, digitalizzazione e innovazione (come i temporary export manager, i digital manager e gli innovation manager).",
    },
    table: {
      title: "Agevolazione prevista",
      content:
        "Con una dotazione di 4 miliardi di euro riservata in prevalenza alle PMI, ma accessibile alle imprese di ogni dimensione, il Fondo 394 si declina in una scelta di diverse tipologie di finanziamenti a tassi agevolati, a cui si aggiunge una quota di cofinanziamento a fondo perduto del 10% (in regime de minimis): fino a 100 mila euro per ogni progetto ammesso.",
      subContent:
        "*Questo Credito è compatibile e quindi cumulabile con altri aiuti previsti per la Transizione 4.0\n*Questo credito è cumulabile con Industria 5.0\n*La finestra di tempo entro cui devono presentare tale domanda sarà dal 14 Aprile al 30 Maggio 2025.",
    },
    services: {
      title: "Le principali agevolazioni",
      subTitle:
        "Analizzando i bisogni e le esigenze delle imprese, aiutiamo gli imprenditori a trovare le opportunità più convenienti per l’agevolazione dei loro investimenti.",
    },
  },
  clickDay: {
    header: {
      header: "Finanza agevolata",
      title: "CLICK DAY",
      subTitle: "La gara di velocità degli incentivi",
    },
    capitalGoods: {
      header: "Come si vincono i click day?",
      columnOneTitle: "Cos’è il click day",
      columnOne:
        "La maggior parte delle agevolazioni sono gestite a click day. Questo significa che la domanda per richiedere una determinata agevolazione deve essere presentata all’apertura dello sportello in quanto i fondi a disposizione termineranno nei primi minuti (o spesso nei primi secondi) dall’apertura dello sportello. Le domande poi sono controllate in ordine di presentazione (i cosiddetti incentivi a sportello), motivo per il quale viene a crearsi una vera e propria gara di velocità di compilazione e presentazione delle pratiche comunemente definito nel settore “Click day”.",
      columnTwoTitle: "Come gestiamo i click day",
      columnTwo:
        "Nel corso degli anni abbiamo allenato circa 30 persone ad eseguire questi click day per le aziende che decidono di presentare domanda per bandi a sportello. La gestione di questi giorni deve essere ben studiata ed organizzata, al fine di mettere in condizione tutti i nostri cliccatori di fare il miglior tempo possibile. Utilizziamo manuali, guide e svariate tecniche apprese nel corso della nostra esperienza per garantire ai nostri clienti il maggior tasso di successo.",
    },
    externalink: {
      title:
        "Scopri quali bandi sono attualmente attivi e crea la soluzione più adatta a te!",
      button: {
        title: "SCOPRI I BANDI",
        link: "/build-your-solution",
      },
    },
  },
  contributionsManagement: {
    header: {
      header: "Servizi",
      title: "GESTIONE CONTRIBUTI",
      subTitle: "Gestione in toto dei contributi italiani ed europei",
    },
    types: {
      title: "Scopri come funziona",
      columnOne:
        "Il nostro team si occupa di seguire i progetti dalla costruzione del progetto fino all'erogazione dei fondi. Nello specifico nella prima fase aiutiamo l'impresa a costruire il suo progetto, partendo dalle idee dell'imprenditore, seguendo le linee guida dettate dal bando. Successivamente ci occupiamo di presentare la domanda, gestendo per i nostri clienti anche i click day, grazie ad un team composto da circa 30 persone allenate ad inviare le domande il più velocemente possibile. ",
      columnTwo:
        "Una volta ammesse, ci occupiamo di seguire l’impresa nei suoi investimenti, dando le opportune indicazioni onde evitare problematiche nella rendicontazione. In ultima fase ci occupiamo di inviare tutta la documentazione riguardante l'investimento all'ente che erogherà il contributo spettante all'impresa. Seguiamo le agevolazioni del Nord, Centro e Sud Italia.",
    },
    benefitsFollowed: {
      title: "Agevolazioni seguite",
      steps: [
        {
          title: "Bandi camerali",
          content:
            "Le Camere di Commercio locali emettono bandi per supportare le imprese del territorio. Questi possono includere contributi a fondo perduto, voucher per la digitalizzazione, finanziamenti per l'internazionalizzazione, formazione e supporto all'innovazione. Sono rivolti principalmente alle piccole e medie imprese (PMI) e mirano a stimolare lo sviluppo economico locale.",
          icon: "/images/local/PROSSIMITI-icon-Ascolto2.svg",
        },
        {
          title: "Bandi regionali",
          content:
            "Le regioni pubblicano bandi e agevolazioni per promuovere la crescita economica e sociale nel proprio territorio. Questi possono riguardare finanziamenti per l'innovazione tecnologica, la ricerca e sviluppo, la formazione professionale, l'occupazione e lo sviluppo sostenibile. Spesso co-finanziati dall'Unione Europea, i bandi regionali rispondono a esigenze specifiche delle economie locali",
          icon: "/images/local/PROSSIMITI-icon-Focus.svg",
        },
        {
          title: "Bandi Nazionali",
          content:
            "l governo centrale, attraverso ministeri e agenzie come il Ministero delle Imprese e del Made in Italy (ex MISE), emette bandi e agevolazioni su scala nazionale. Questi programmi mirano a sostenere settori strategici, promuovere l'innovazione, la digitalizzazione, la sostenibilità ambientale e l'internazionalizzazione delle imprese italiane. Esempi includono il Piano 4.0 e 5.0, Ricerca e Sviluppo, la Nuova Sabatini, agevolazioni Simest per l'export, agevolazioni gestite da Invitalia, il Bando Isi Inail",
          icon: "/images/local/PROSSIMITI-icon-KnowHowOperativo.svg",
        },
      ],
    },
    services: {
      title: "Scopri gli altri servizi",
      subTitle:
        "Analizzando i bisogni e le esigenze delle imprese, aiutiamo gli imprenditori a trovare le opportunità più convenienti per l’agevolazione dei loro investimenti.",
    },
  },
  industryAppraisalsFour: {
    header: {
      header: "Servizi",
      title: "PERIZIE INDUSTRIA 4.0",
      subTitle: "Perizie per l’accesso al credito del piano transizione 4.0",
    },
    types: {
      title: "Scopri come funziona",
      columnOne:
        "Grazie all’iscrizione all’ordine degli ingegneri di Modena sezione A, possiamo produrre e firmare le perizie asseverata utili a verificare i 5+2 requisiti richiesti dalla normativa per accedere al credito di imposta 4.0. Ci occupiamo non solo di verificare il soddisfacimento dei requisiti ma anche di aiutare l’imprese da un punto di vista amministrativo, controllando che la documentazione riferita al bene strumentale sia corretta ed utile ai fini della determinazione del credito di imposta.",
    },
    benefitsFollowed: {
      title: "IL NOSTRO LAVORO",
      steps: [
        {
          title: "Verifica della documentazione",
          content:
            "Ci occupiamo di verificare che la documentazione inerente al bene acquistato sia corretta. Nel caso di problematiche ci interfacciamo direttamente con fornitori o intermediari.",
          icon: "/images/local/PROSSIMITI-icon-Ascolto2.svg",
        },
        {
          title: "Visita in loco",
          content:
            "Veniamo direttamente nella vostra sede per fare foto e video del processo produttivo e di come il bene si inserisce all’interno di esso. Diamo consigli al fine di migliorare il processo ed ottimizzarlo il più possibile.",
          icon: "/images/local/PROSSIMITI-icon-Focus.svg",
        },
        {
          title: "Redazione perizia e analisi tecnica",
          content:
            "Redigiamo la perizia e l’analisi tecnica, descrivendo nel dettaglio il soddisfacimento di tutti i requisiti, nello specifico quelli di interconnessione ed integrazione con il sistema informativo aziendale.",
          icon: "/images/local/PROSSIMITI-icon-KnowHowOperativo.svg",
        },
        {
          title: "Conservazione documentale e controlli",
          content:
            "Inviamo un fascicolo digitale contenente la perizia, l’analisi tecnica e tutta la documentazione a corredo a dimostrazione dei soddisfacimenti della normativa sia da un punto di vista tecnico che documentale. Forniamo assistenza in caso di controllo da parte dell’Agenzia delle Entrate",
          icon: "/images/local/PROSSIMITI-icon-KnowHowOperativo.svg",
        },
      ],
    },
    services: {
      title: "Scopri gli altri servizi",
      subTitle:
        "Analizzando i bisogni e le esigenze delle imprese, aiutiamo gli imprenditori a trovare le opportunità più convenienti per l’agevolazione dei loro investimenti.",
    },
  },
  industryCertificationFive: {
    header: {
      header: "Servizi",
      title: "CERTIFICAZIONE INDUSTRIA 5.0",
      subTitle:
        "Certificazione ex ante, ex post e comunicazioni al Gse per Industria 5.0",
    },
    types: {
      title: "Scopri come funziona",
      columnOne:
        "Grazie al supporto di un EGE (esperti gestione energia) gestiamo il lungo iter per poter accedere all’agevolazione di industria 5.0. Grazie alla nostra rete siamo inoltre in grado di indicare fornitori che possiedono le competenze per poter installare impianti fotovoltaici composti dai moduli con la potenza e le caratteristiche imposte dalla normativa, ovvero prodotti in Unione Europea, al fine di agevolare anche il vostro impianto.",
    },
    benefitsFollowed: {
      title: "IL NOSTRO LAVORO",
      steps: [
        {
          content:
            "Analisi energetica del sito o del processo produttivo (stato di fatto)",
          icon: "/images/local/PROSSIMITI-icon-Ascolto2.svg",
        },
        {
          content:
            "Raccolta dati tecnici ed energetici relativi alle iniziative di investimento già programmate",
          icon: "/images/local/PROSSIMITI-icon-Focus.svg",
        },
        {
          content:
            "Generazione delle iniziative di risparmio energetico e discussione con il committente",
          icon: "/images/local/PROSSIMITI-icon-KnowHowOperativo.svg",
        },
        {
          content:
            "Stesura progetto di investimento / efficientamento e analisi del risultato energetico atteso",
          icon: "/images/local/PROSSIMITI-icon-KnowHowOperativo.svg",
        },
        {
          content: "Stesura relazione ex-ante e presentazione pratica al GSE",
          icon: "/images/local/PROSSIMITI-icon-KnowHowOperativo.svg",
        },
        {
          content:
            "Reportistica Stato Avanzamento Lavori e comunicazioni con GSE fino all’ottenimento del credito",
          icon: "/images/local/PROSSIMITI-icon-KnowHowOperativo.svg",
        },
        {
          content:
            "Una volta completato l’investimento: stesura relazione tecnica expost e comunicazione finale al GSE.",
          icon: "/images/local/PROSSIMITI-icon-KnowHowOperativo.svg",
        },
      ],
    },
    services: {
      title: "Scopri gli altri servizi",
      subTitle:
        "Analizzando i bisogni e le esigenze delle imprese, aiutiamo gli imprenditori a trovare le opportunità più convenienti per l’agevolazione dei loro investimenti.",
    },
  },
  noticeAppraisals: {
    header: {
      header: "Servizi",
      title: "PERIZIE BANDO ISI INAIL",
      subTitle:
        "Certificazione ex ante, ex post e comunicazioni al Gse per Industria 5.0",
    },
    types: {
      title: "Scopri come funziona",
      columnOne:
        "A seguito dell’ammissione al bando Isi Inail, l’ente richiede una perizia asseverata volta a dimostrare che l’investimento presentato sia in linea e rispetti i vincoli tecnici previsti dal bando. Grazie all’iscrizione all’ordine degli ingegneri di Modena, i nostri ingegneri possono procedere ad effettuare una visita in loco al fine di poter supportare l’azienda e poter presentare domanda entro i termini spesso molto stretti del bando. Prossimiti S.r.l. inoltre gestisce anche l’intero iter, motivo per il quale la nostra impresa riesce a supportare il cliente in tutte le varie fasi del bando Inail.",
    },
    benefitsFollowed: {
      title: "IL NOSTRO LAVORO",
      steps: [
        {
          content: "Verifica dei requisiti richiesti dal bando",
          icon: "/images/local/PROSSIMITI-icon-Ascolto2.svg",
        },
        {
          content:
            "Analisi dei preventivi in possesso del cliente sulla base dell’asse a cui l’azienda ha deciso di partecipare.",
          icon: "/images/local/PROSSIMITI-icon-Focus.svg",
        },
        {
          content:
            "Eventuale segnalazione di fornitori per la rimozione dell’amianto o per l’acquisto di macchinari",
          icon: "/images/local/PROSSIMITI-icon-KnowHowOperativo.svg",
        },
        {
          content:
            "Visita in loco per la verifica del DVR, per la raccolta documentale e per visionare eventuali macchinari che dovranno essere sostituiti.",
          icon: "/images/local/PROSSIMITI-icon-KnowHowOperativo.svg",
        },
        {
          content:
            "Redazione della perizia e caricamento della documentazione a corredo sul portale Inail.",
          icon: "/images/local/PROSSIMITI-icon-KnowHowOperativo.svg",
        },
      ],
    },
    services: {
      title: "Scopri gli altri servizi",
      subTitle:
        "Analizzando i bisogni e le esigenze delle imprese, aiutiamo gli imprenditori a trovare le opportunità più convenienti per l’agevolazione dei loro investimenti.",
    },
  },
};
